import { PlaceholderPage } from '@/components/PlaceholderPage';

export function Clinics() {
  return <PlaceholderPage titleKey="nav.clinics" modKey="MOD-2 — Clinics" />;
}
